import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

export interface AdminContract {
  id: string;
  name: string;
  link: string;
  jobOpening?: {
    id: string;
    company: {
      id: string;
      name?: string;
      logoLink?: string;
    };
    role?: string;
  };
  showToCompany?: boolean;
  showToCandidate?: boolean;
}

export const useAdminContractsQuery = () => {
  const { getAccessTokenSilently } = useAuth0();

  const {
    data: adminContracts,
    error: adminContractsError,
    isLoading: adminContractsLoading,
  } = useQuery({
    queryKey: QueryKeys.adminContracts,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return request<AdminContract[]>({
        method: "GET",
        path: `/api/admin/contract/`,
        token,
      });
    },
  });

  return {
    adminContracts,
    adminContractsError,
    adminContractsLoading,
  };
};
